/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CredentialsAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CredentialsAction({
  children,
  viewPath = "/App/Auth/SignIn/TwoFactorAuth/CredentialsAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<div
  data-testid="CredentialsAction.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 size="normal"
 color={dtColorsNeutral700}
 text="Back"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../Credentials'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../Credentials'))}
/>
</div>
{children}
</React.Fragment>)
}